module.exports = __webpack_public_path__ + "static/doctorMan-f708538ffc150c231b9ebe3de17e4ae4.png";